import { loginStateDoc } from "src/app/auth/shared/models/loginStateDoc";

export class loginScreens {
  static readonly type = '[loginScreens] Login';
  constructor(public loginScreens: loginStateDoc) {}
}
